<div class="precast-setting">
  @if (preCastData && preCastData.length && preCastData.length > 1) {
    <section class="dash-container">
      <mat-divider class="pb-24"></mat-divider>
      <div class="savebtn">
        <button mat-raised-button color="primary" (click)="saveBtn()">SAVE</button>
      </div>
      <app-admin-grid-table [dataSource]="preCastData" [appRoles]="appRoles"></app-admin-grid-table>
    </section>
  }
</div>
